import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { AIRFLOW_PATHS } from './paths';

/** Airflow: вертушка — четыре лопасти вокруг оси. */
export const AirflowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {AIRFLOW_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
